import jsKit from './jsKit';

const authWithGoogle = async (jwtToken) => {
  const action = jwtToken.state || 'signin';
  const trigger = document.querySelector('#g_id_onload');

  const formData = new FormData();
  formData.append('token', jwtToken.credential);
  formData.append('provider', 'google');
  formData.append('basket', (trigger || {}).getAttribute('data-basket') || false);

  const data = await jsKit.requestUrl(`/client/oauth/${action}`, 'json', 'POST', formData);

  if (data.status === 200) {
    if (data.redirect === 'reload') {
      document.location.reload();
    } else {
      document.location = data.redirect;
    }
  } else {
    jsKit.showNotificationsPanel(data.message);
  }
};

export const appendOAuthComponents = () => {
  if (!document.querySelector('#g_id_onload')) return;

  const tag = document.createElement('script');
  tag.src = 'https://accounts.google.com/gsi/client';
  document.getElementsByTagName('body')[0].appendChild(tag);

  globalThis.authWithGoogle = authWithGoogle;
};
